// Export a factory that builds the options object used by Highcharts.stockChart.
// We accept the Highcharts instance and the prepared chartData so that
import { getTimezoneLabel } from "../../utils/utility";
// formatters that reference Highcharts still work without importing it here.
export default function createHighchartsOptions(Highcharts, chartData) {
  return {
    chart: {
      height: null, // Let Highcharts calculate height based on container
      marginRight: 20,
      zoomType: "x",
      panning: {
        enabled: true,
      },
      panKey: "shift",
      resetZoomButton: {
        // styles of reset zoom button
        position: {
          x: -50,
          y: -32,
        },
        theme: {
          padding: 4,
          r: 4,
        },
      },
      events: {
        exportData: function (e) {
          const headerRow = e.dataRows[0];
          headerRow[0] = `Timestamp (${getTimezoneLabel()})`;
          headerRow[1] = "Status";
          headerRow.push("Reason");

          const points = this.series[0].points;

          for (let i = 1; i < e.dataRows.length; i++) {
            // Replace 0/1 with Offline/Online in the status column
            if (e.dataRows[i][1] === 0) {
              e.dataRows[i][1] = "Offline";
            } else if (e.dataRows[i][1] === 1) {
              e.dataRows[i][1] = "Online";
            }
            const point = points[i - 1];
            const reason = point?.rsn || point?.options?.rsn || "";
            e.dataRows[i].push(reason);
          }
          // Remove the second header row for XLS export
          if (this.currentExportFormat === "xls" && e.dataRows.length > 1) {
            e.dataRows[1][0] = null;
            e.dataRows[1][1] = null;
            e.dataRows[1][2] = null;
          }
        },
      },
    },
    title: {
      text: '<span style="color:white">.</span>',
      align: "left",
      style: { color: "#333", fontWeight: "bold", fontSize: "16px" },
    },

    credits: {
      enabled: false,
    },

    rangeSelector: {
      enabled: false,
    },
    navigator: { enabled: false },

    scrollbar: {
      enabled: false,
    },

    xAxis: {
      type: "datetime",
      ordinal: false,
      labels: {},
    },

    yAxis: {
      title: {
        text: null,
      },
      opposite: false,
      tickPositions: [0, 1],
      min: 0,
      max: 1,
    },

    tooltip: {
      useHTML: true,
      xDateFormat: "%d/%m/%Y, %H:%M:%S",
      formatter: function () {
        return `<b>${Highcharts.dateFormat("%e %b %Y %H:%M:%S", this.x)}</b><br/>Status: <span style="color:${this.y === 1 ? "green" : "red"}; font-weight: 700;">${this.y === 1 ? "ONLINE" : "OFFLINE"}</span> ${this.y === 0 ? `<br/> Reason: ${this.rsn || "N/A"}` : ""} `;
      },
      split: false,
      shared: false,
      followPointer: false,
      outside: true,
      positioner: function (labelWidth, labelHeight, point) {
        const chart = this.chart;
        let x, y;
        x = chart.plotLeft + point.plotX - labelWidth / 2;
        y = -20;
        if (x < chart.plotLeft) {
          x = chart.plotLeft;
        }
        if (x + labelWidth > chart.plotLeft + chart.plotWidth) {
          x = chart.plotLeft + chart.plotWidth - labelWidth;
        }
        return { x: x, y: y };
      },
    },

    series: [
      {
        name: "Steps",
        type: "area",
        step: "left",
        data: chartData,
        color: "rgba(54, 182, 96, 1)",
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(54, 182, 96, 0.8)"],
            [1, "rgba(54, 182, 96, 0.3)"],
          ],
        },
        lineWidth: 1,
        marker: {
          enabled: false,
        },
        dataGrouping: {
          enabled: false,
        },
      },
    ],

    plotOptions: {
      series: {
        turboThreshold: 0,
        states: {
          hover: {
            lineWidthPlus: 0,
          },
        },
      },
    },
    exporting: {
      enabled: true,
      allowHTML: true,
      buttons: {
        contextButton: {
          enabled: true,
          menuItems: ["viewFullscreen", "separator", "downloadCSV", "downloadXLS", "downloadPNG"],
        },
      },
      menuItemDefinitions: {
        // Override the default CSV download click
        downloadCSV: {
          onclick: function () {
            this.currentExportFormat = "csv";
            this.downloadCSV();
          },
        },
        // Override the default XLS download click
        downloadXLS: {
          onclick: function () {
            this.currentExportFormat = "xls";
            this.downloadXLS();
          },
        },
      },
    },
  };
}
